export const apiKey = process.env.REACT_APP_ABLY_API_KEY;
export const channelName = process.env.REACT_APP_ABLY_BROADCAST_CHANNEL_NAME;

export const chatChannelName = process.env.REACT_APP_ABLY_CHAT_CHANNEL_NAME;
export const activityStatusChannel = process.env.REACT_APP_ABLY_TU_STATUS_CHANNEL;
export const chatNotifications = process.env.REACT_APP_ABLY_CHAT_NOTIFICATIONS_CHANNEL
export const autoSearchKey = process.env.REACT_APP_ADDRESS_AUTOSEARCH_KEY
export const addTeamNoteKey = process.env.REACT_APP_ABLY_ADD_TEAM_NOTES

export const pharmacy_login_user = 'pharmacy-login-user'
export const pharmacy_login_2fa_check = 'pharmacy-login-2fa/check'
export const pharmacy_login_2fa_email_send = 'pharmacy-login-2fa/email/send'
export const pharmacy_login_2fa_email_verify = 'pharmacy-login-2fa/email/verify'
export const pharmacy_login_2fa_phone_send = 'pharmacy-login-2fa/phone/send'
export const pharmacy_login_2fa_phone_verify = 'pharmacy-login-2fa/phone/verify'
export const pharmacy_login_2fa_authenticator_setup = 'pharmacy-login-2fa/authenticator/setup'
export const pharmacy_login_2fa_authenticator_confirm = 'pharmacy-login-2fa/authenticator/confirm'
export const pharmacy_login_2fa_authenticator_verify = 'pharmacy-login-2fa/authenticator/verify'
export const pharmacy_login_2fa_ip_authorization_verify = 'pharmacy-login-2fa/ip-authorization/verify'
export const pharmacy_user_permission = 'pharmacy-user-permission'
export const pharmacy_user_feature_flags = 'pharmacy-user/feature-flags'
// Module-permission system (see useMyModules): which top-nav modules the logged-in user has.
export const pharmacy_user_my_modules = 'pharmacy-user/my-modules'
// Admin screen privacy (F9 x5). Presentation only — see useAdminStealth.
export const pharmacy_user_ui_visibility = 'pharmacy-user/ui-visibility'
export const pharmacy_user_supernova_access = 'pharmacy-user/supernova-access'
// Team screen module assignment for a specific team member (GET assignable+assigned, POST { modules }).
// NOTE: backend registers these WITHOUT the pharmacy-user/ prefix (routes/api.php: team/user/{id}/modules).
export const pharmacy_team_user_modules = (userId) => `team/user/${userId}/modules`
// Department ("team") module assignment — same assignable/assigned shape as the user endpoint.
export const pharmacy_team_department_modules = (departmentId) => `team/department/${departmentId}/modules`
export const pharmacy_user_profile = 'pharmacy-user-profile'
export const pharmacy_user_update_profile = 'pharmacy-user-update-profile'
export const pharmacy_uprofilecover_update = 'pharmacy-uprofilecover-update'

export const pharmacy_birthday_context = 'pharmacy-birthday-context'
export const pharmacy_pharmacist_verification_context = 'pharmacy-pharmacist-verification-context'
export const pharmacy_pharmacist_verification = 'pharmacy-pharmacist-verification'
export const pharmacy_audit_lock_date_context = 'pharmacy-audit-lock-date-context'
export const pharmacy_birthday_dob = 'pharmacy-birthday-dob'
export const pharmacy_birthday_reminder = 'pharmacy-birthday-reminder'
export const pharmacy_birthday_quote = 'pharmacy-birthday-quote'
export const pharmacy_birthday_wishes = 'pharmacy-birthday-wishes'

export const pharmacy_birthday_message = 'pharmacy-birthday-message'
export const pharmacy_today_birthdays = 'pharmacy-birthday-today'
// export const pharmacy_user_profile = 'pharmacy-user-profile'
export const pharmacy_user_skip_dob_prompt = 'pharmacy-user-dob-prompt-skip'
export const pharmacy_user_update_dob = 'pharmacy-user-update-dob'

export const pharmacy_stat_holiday = 'pharmacy-stat-holiday'
export const pharmacy_user_checkinout = 'pharmacy-checkin-statholiday'
export const pharmacy_timeoff_request = 'pharmacy-timeoff-request'
export const pharmacy_timeoff_lists = 'pharmacy-timeoff-list'
export const pharmacy_alluser_data = 'pharmacy-alluser-data'
export const pharmacy_user_team_shift = 'pharmacy-user-team-shift'
export const edit_pharmacy_timeoff_list = 'pharmacy-timeoff-list-update'
export const pharmacy_timeoff_list_delete = 'pharmacy-timeoff-list-delete'

export const pharmacy_add_wall_post = 'pharmacy-add-wall-post'
export const pharmacy_wall_post_list = 'pharmacy-wall-post-list'
export const pharmacy_user_wall_post_lists = 'pharmacy-profile-wallpost'
export const pharmacy_user_comments = 'pharmacy-user-comments'
export const pharmacy_user_comments_list = 'pharmacy-single-comment-list'
export const pharmacy_add_fcmtoken = 'pharmacy-add-fcmtoken'
export const pharmacy_user_comments_reply = 'pharmacy-user-comments-reply'
// export const pharmacy_reply_list = 'pharmacy-reply-list'
export const pharmacy_reply_list = 'pharmacy-comment-single-reply-list'
export const pharmacy_brodcast_notifications = 'pharmacy-brodcast-notifications'
export const pharmacy_timesheet_dates = 'pharmacy-timesheet-dates'
export const pharmacy_user_post_likes = 'pharmacy-user-post-likes'
export const pharmacy_likes_list = 'pharmacy-likes-list'
export const pharmacy_wall_post_delete = 'pharmacy-wallpost-delete'
export const pharmacy_user_comment_likes = 'pharmacy-user-comment-likes'
export const pharmacy_group_list = 'pharmacy-chat-user-list'

export const pharmacy_chat_messages = 'pharmacy-chat-messages'
export const pharmacy_message_list = 'pharmacy-message-user'
export const pharmacy_add_chat_group = 'pharmacy-add-chat-group'
export const pharmacy_chat_group_list = 'pharmacy-group-list'

// export const pharmacy_intiate_chat = 'pharmacy-intiate-chat'
// export const pharmacy_add_messages_to_group = 'pharmacy-add-messages-to-group'
export const pharmacy_get_chat_message = 'pharmacy-get-chat-message'
export const pharmacy_get_previous_messages = 'pharmacy-get-previous-messages'
export const pharmacy_user_appreciation = 'pharmacy-user-appreciation'
// export const pharmacy_get_recent_chats = 'pharmacy-get-recent-chats'
export const pharmacy_read_messages = 'pharmacy-read-messages'

export const pharmacy_patient_province = 'pharmacy-patient-province'
export const pharmacy_patient_data = 'pharmacy-patient-winrx-data'
export const pharmacy_add_patient = 'pharmacy-add-patient'
export const pharmacy_patient_list = 'pharmacy-patient-list'

export const pharmacy_patient_chat_patients = 'pharmacy-patient-chats/patients'
export const pharmacy_patient_chats = (patientId) => `pharmacy-patient-chats/${patientId}`
export const pharmacy_patient_chats_unread_summary = 'pharmacy-patient-chats/unread-summary'
export const pharmacy_patient_chats_read = (patientId) => `pharmacy-patient-chats/${patientId}/read`

export const pharmacy_pacmed_patients = 'pharmacy-pacmed/patients'
export const pharmacy_pacmed_fod_audit = 'pharmacy-pacmed/fod-audit'
export const pharmacy_pacmed_patient_fda_documents = (patientId) => `pharmacy-pacmed/patients/${patientId}/fda-documents`
export const pharmacy_pacmed_patient_doctor_timeline = (patientId) => `pharmacy-pacmed/patients/${patientId}/doctor-timeline`

export const pharmacy_patient_update_status = 'pharmacy-patient-update-status'
export const pharmacy_update_patient = 'pharmacy-update-patient'
export const pharmacy_delete_patient = 'pharmacy-delete-patient'
export const pharmacy_patient_rx_acknowledgment = 'pharmacy-patient-rx-acknowledgment'
export const common_message_send = 'common-message-send'

export const get_clinic = 'get-clinic'
export const pharmacy_patient_link_clinic = 'pharmacy-patient-link-clinic'
export const pharmacy_get_patient_notes = 'pharmacy-get-patient-notes'
export const p_reminder_nofication = 'p-reminder-nofication'
export const pharmacy_save_patient_notes = 'pharmacy-save-patient-notes'
export const pharmacy_patient_send_photo_link = 'pharmacy-patient-send-photo-link'
export const get_doctors = 'get-doctors'

export const pharmacy_oat_form_pref_update = 'pharmacy-oat-form-pref-update'
export const doctor_new_doctor = 'doctor-add-new'
export const pharmacy_active_patient_list = 'pharmacy-active-patient-list'
export const pharmacy_update_notification_clinic_form = 'pharmacy-update-notification-clinic-form'
export const pharmacy_update_notification_srfax_form = 'pharmacy-update-notification-srfax-form'
export const get_pharmacies_list = 'get-pharmacies'
export const pharmacy_rx_transfer_form = 'pharmacy-rx-transfer-form'
export const pharmacy_new_add_clinic = 'pharmacy-new-add-clinic'

export const pharmacy_rx_transfer_fax_form = 'pharmacy-rx-transfer-fax-form'
export const pharmacy_dr_notification_emergency_supply = 'pharmacy-dr-notification-emergency-supply'
export const pharmacy_dr_notification_emergency_fax_form = 'pharmacy-dr-notification-emergency-fax-form'
export const pharmacy_anti_viral_request_form = 'pharmacy-anti-viral-request-form'
export const pharmacy_anti_viral_srfax_form = 'pharmacy-anti-viral-srfax-form'
export const pharmacy_missing_rx_form = 'pharmacy-missing-rx-form'
export const pharmacy_missing_rx_srfax_form = 'pharmacy-missing-rx-srfax-form'
export const pharmacy_emergency_supply_continuity_form = 'pharmacy-emergency-supply-continuity-form'
export const pharmacy_patient_agreement_for_dosing = 'pharmacy-patient-agreement-for-dosing'
export const pharmacy_plan_g_form = 'pharmacy-plan-g-form'
export const pharmacy_plan_g_srfax_form = 'pharmacy-plan-g-srfax-form'
export const pharmacy_plan_z_form = 'pharmacy-plan-z-form'
export const pharmacy_plan_z_srfax_form = 'pharmacy-plan-z-srfax-form'
export const pharmacy_doctor_comm_withoutout_form = 'pharmacy-doctor-comm-withoutout-form'
export const pharmacy_doctor_communication_letter_head = 'pharmacy-doctor-communication-letter-head'
export const pharmacy_doctor_comm_withoutout_srfax = 'pharmacy-doctor-comm-withoutout-srfax'
export const pharmacy_doctor_communication_srfax = 'pharmacy-doctor-communication-srfax'
export const pharmacy_pharmacist_prescriber_communication_form = 'pharmacy-pharmacist-prescriber-communication-form'
export const pharmacy_pharmacist_prescriber_communication_srfax_form = 'pharmacy-pharmacist-prescriber-communication-srfax-form'
export const pharmacy_team_add_notes = 'pharmacy-team-add-notes'
export const pharmacy_update_label_to_margin = 'update-pharmacy-label-margin'
export const pharmacy_ai_chat = 'pharmacy-ai/chat'
export const pharmacy_get_consent_email_data = 'pharmacy-consent-email-data'
export const pharmacy_add_consent_email_data = 'add-pharmacy-consent-email'
export const pharmacy_update_authentication_phone_number = 'update-pharmacy-phone-number'
export const pharmacy_get_search_history = 'pharmacy-ajax-search'
export const pharmacy_get_authentication_phone_number = 'pharmacy-auth-phone-number-data'

export const pharmacy_request_original_rx_oat_form = 'pharmacy-request-original-rx-oat-form'
export const pharmacy_request_original_fax_form = 'pharmacy-request-original-fax-form'
export const pharmacy_coverage_patient_list = 'pharmacy-coverage-patient-list'
export const pharmacy_patient_notification_list = 'pharmacy-patient-notification-list'
export const pharmacy_delete_all_system_generated_notes = 'delete-all-system-generated-notes'
export const pharmacy_team_notes = 'pharmacy-team-notes'

export const pharmacy_patient_notes_reply = 'pharmacy-patient-notes-reply'
export const pharmacy_patient_notes_markasread = 'pharmacy-patient-notes-markasread'
export const pharmacy_patient_notes_acknowledge = 'pharmacy-patient-notes-acknowledge'
export const pharmacy_module_search = 'module-search'
export const pharmacy_file_manager_create_folder = 'pharmacy-folder-manager'
export const pharmacy_file_manager_get_files = 'pharmacy-folder-manager-files'
export const pharmacy_srfax_log_list = 'pharmacy-srfax-log-list'
export const pharmacy_compound_list = 'pharmacy-compound-list'
export const pharmacy_add_new_compound = 'pharmacy-add-new-compound'
export const pharmacy_agreement_compound_form = 'pharmacy-agreement-compound-form'

export const pharmacy_agreement_compound_srfax_form = 'pharmacy-agreement-compound-srfax-form'
export const pharmacy_controlled_request_form = 'pharmacy-controlled-request-form'
export const pharmacy_price_compound_list = 'pharmacy-price-compound-list'
export const pharmacy_add_compound_price_list = 'pharmacy-add-compound-price-list'
export const pharmacy_delete_compound = 'pharmacy-delete-compound'
export const pharmacy_price_list_delete = 'pharmacy-price-list-delete'
export const pharmacy_compound_order_form = 'pharmacy-compound-order-form'
export const pharmacy_compound_order_form_new = 'pharmacy-compound-order-form-new'
export const pharmacy_compound_order_form_new_srfax = 'pharmacy-compound-order-form-new-srfax'
export const pharmacy_compound_order_srfaxform = 'compound-order-srfax-form'
export const pharmacy_compound_form = 'pharmacy-compound-form'

export const pharmacy_compound_srfaxform = 'pharmacy-compound-srfaxform'

// Compound DINs endpoints
export const pharmacy_compound_dins_compounds = 'pharmacy-compound-dins/compounds'
export const pharmacy_compound_dins_alphabet_compounds_search = 'pharmacy-compound-dins/alphabet-compounds-search'
export const pharmacy_compound_dins = 'pharmacy-compound-dins'
export const pharmacy_compound_dins_by_id = 'pharmacy-compound-dins'
export const pharmacy_compound_dins_search_winrx_drug = 'pharmacy-compound-dins/search-winrx-drug'
export const pharmacy_compound_dins_compound_details = 'pharmacy-compound-dins/compound-details'
export const pharmacy_compound_dins_master_compounds = 'pharmacy-dins/master-compounds'
export const pharmacy_compound_dins_get_drug_cost = 'pharmacy-dins/get-compound-drug-cost'
export const pharmacy_compound_logs_patients = 'pharmacy-compound-logs/patients'
export const pharmacy_compound_logs_needs_review = 'pharmacy-compound-logs/needs-review'
export const pharmacy_compound_logs_preview = 'pharmacy-compound-logs/preview'
export const pharmacy_compound_logs = 'pharmacy-compound-logs'
export const pharmacy_compound_logs_latest_by_compound = 'pharmacy-compound-logs/latest-by-compound'
export const pharmacy_compound_logs_show = 'pharmacy-compound-logs/show'
export const pharmacy_compound_items = 'pharmacy-compound-items'
export const pharmacy_supervisior_search = 'pharmacy-supervisior-search'
export const pharmacy_addnew_sdelivery_driver = 'pharmacy-addnew-sdelivery-driver'
export const pharmacy_addnew_delivery_driver = 'pharmacy-addnew-delivery-driver'
export const pharmacy_driver_list = 'pharmacy-driver-list'
export const pharmacy_driver_default_pharmacist_options = 'pharmacy-driver-default-pharmacist-options'
export const pharmacy_driver_list_counts = 'pharmacy-driver-list-counts'
export const pharmacy_update_driver_detail = 'pharmacy-update-driver-detail'
export const pharmacy_delete_driver_detail = 'pharmacy-delete-driver-detail'
export const pharmacy_assign_assistant_driver = 'assign-assistant-driver'
export const pharmacy_srfax_log_pdf = 'pharmacy-srfax-log-pdf'
export const pharmacy_addnew_custom_delivery = 'pharmacy-addnew-custom-delivery'
export const pharmacy_patient_recurrence_delivery = 'pharmacy-patient-recurrence-delivery'
export const pharmacy_delete_recurrence_delivery = 'pharmacy-delete-recurrence-delivery'

export const pharmacy_daily_dispense_list = 'pharmacy-daily-dispense-list'
export const pharmacy_dispensedelivery_moveto_next_date = 'pharmacy-dispensedelivery-moveto-next-date'
export const pharmacy_dispensedelivery_update_status = 'pharmacy-dispensedelivery-update-status'
export const patient_archieved_deliveries = 'patient-archieved-deliveries'
export const patient_archieved_deliveries_mark_delivered = 'patient-archieved-deliveries/mark-delivered'
export const patient_route_list = 'patient-route-list'
export const patient_archieved_setpin_delivery = 'patient-archieved-setpin-delivery'
export const patient_archieved_patient_updatenotes = 'patient-archieved-patient-updatenotes'
export const pharmacy_audit_trail = 'pharmacy-accountability/audit-trail'
export const pharmacy_audit_trail_team = 'pharmacy-accountability/audit-trail/team'
export const pharmacy_audit_trail_routes = 'pharmacy-accountability/audit-trail/routes'
export const pharmacy_audit_trail_patients_base = 'pharmacy-accountability/audit-trail/routes'
export const pharmacy_audit_trail_route_team_base = 'pharmacy-accountability/audit-trail/routes'
export const pharmacy_audit_trail_route_deliveries_base = 'pharmacy-accountability/audit-trail/routes'
export const pharmacy_audit_trail_patient_medications_base = 'pharmacy-accountability/audit-trail/patients'
export const pharmacy_audit_trail_live_drivers = 'pharmacy-accountability/audit-trail/live-drivers'
export const pharmacy_audit_trail_route_release = 'pharmacy-accountability/audit-trail/routes/release'
export const pharmacy_audit_trail_live_location_requests = 'pharmacy-accountability/audit-trail/live-location-requests'
export const pharmacy_audit_trail_handover_requests = 'pharmacy-accountability/audit-trail/handover-requests'
export const pharmacy_audit_trail_returns = 'pharmacy-accountability/audit-trail/returns'
export const pharmacy_audit_trail_pending_returns = 'pharmacy-accountability/audit-trail/pending-returns'
export const pharmacy_audit_trail_verify_missed_pdf = 'pharmacy-accountability/audit-trail/verify-missed-pdf'
export const pharmacy_audit_trail_pharmacy_drivers = 'pharmacy-accountability/audit-trail/pharmacy-drivers'
export const pharmacy_audit_trail_pdf = 'pharmacy-accountability/audit-trail/audit-trial-pdf'
export const pharmacy_audit_sheet_pdf = 'pharmacy-accountability/audit-trail/delivery-log-pdf'
export const inventory_accountability_distributors = 'inventory-accountability/distributors'
export const inventory_accountability_winrx_comparison = 'inventory-accountability/winrx-comparison'
export const inventory_accountability_setup_status = 'inventory-accountability/setup/status'
export const inventory_accountability_setup_import_winrx = 'inventory-accountability/setup/import-winrx'
export const inventory_accountability_dashboard = 'inventory-accountability/dashboard'
export const inventory_accountability_dose_details = 'inventory-accountability/dose-details'
export const inventory_accountability_reports = 'inventory-accountability/reports'
export const inventory_accountability_reports_export_pdf = 'inventory-accountability/reports/export-pdf'
export const inventory_accountability_reports_export_csv = 'inventory-accountability/reports/export-csv'
export const inventory_accountability_reports_details = 'inventory-accountability/reports/details'
export const inventory_accountability_drugs = 'inventory-accountability/drugs'
export const inventory_accountability_drug_search = 'inventory-accountability/drugs/search'
export const inventory_accountability_counts = 'inventory-accountability/counts'
export const inventory_accountability_adjustments = 'inventory-accountability/adjustments'
export const inventory_accountability_returns_queue = 'inventory-accountability/returns-queue'
export const inventory_accountability_destruction = 'inventory-accountability/destruction'
export const inventory_accountability_count_sessions = 'inventory-accountability/count-sessions'
export const inventory_accountability_supplier_returns = 'inventory-accountability/supplier-returns'
export const inventory_accountability_recalls = 'inventory-accountability/recalls'
export const inventory_accountability_lots = 'inventory-accountability/lots'
export const inventory_accountability_sync_status = 'inventory-accountability/sync-status'
export const inventory_accountability_discrepancies = 'inventory-accountability/discrepancies'
export const inventory_accountability_receiving_mckesson_import = 'inventory-accountability/receiving/mckesson-import'
export const inventory_accountability_receiving_mckesson_import_status = 'inventory-accountability/receiving/mckesson-import-status'
export const inventory_accountability_receiving_mckesson_save = 'inventory-accountability/receiving/mckesson-save'
export const inventory_accountability_receiving_catalog_refresh = 'inventory-accountability/receiving/catalog-refresh'
export const inventory_accountability_receiving_catalog_status = 'inventory-accountability/receiving/catalog-status'
export const inventory_accountability_compound_sources = 'inventory-accountability/compound-sources'
export const inventory_accountability_compound_usage = 'inventory-accountability/compound-usage'
export const inventory_accountability_receiving_lines = 'inventory-accountability/receiving/lines'
export const inventory_accountability_receiving = 'inventory-accountability/receiving'
export const pharmacy_patient_prescriptions_details = 'pharmacy-patient-prescriptions-details'
export const delivery_video_calls = 'delivery-video-calls'
export const delivery_video_calls_auto_pickup_setting = 'delivery-video-calls/auto-pickup-setting'
export const pharmacist_driver_video_calls = 'pharmacist-driver-video-calls'
export const pharmacy_driver_clinic_call_logs = 'driver-clinic-call-logs'
export const pharmacy_rxnumber_archieved_list = 'pharmacy-rxnumber-archieved-list'
export const pharmacy_patient_archieved_sheet = 'pharmacy-patient-arvhieved-sheet'
export const pharmacy_rx_acknowledge = 'pharmacy-rx-acknowledge'
export const pharmacy_patient_dlabels = 'pharmacy-patient-dlabels'
export const pharmacy_rx_labels_list = 'rxlables-list'

export const pharmacy_update_rxlabelmute = 'pharmacy-update-rxlabelmute'
export const print_deliveries_labelsheet = 'print-deliveries-labelsheet'
export const delete_rx_labels = 'delete-rxlables'
export const patient_medicine_list = 'patient-medicine-list'
export const expiring_rxsheet = 'expiring-rxsheet'
export const expiring_rxsheet_v2 = 'expiring-rxsheet-v2'
export const pharmacy_patient_syncdeliverires_winrx = 'pharmacy-patient-syncdeliverires-winrx'
export const pharmacy_rxnumber_date_sync_assignment = 'pharmacy-rxnumber-date-sync/assignment'
export const pharmacy_rxnumber_date_sync = 'pharmacy-rxnumber-date-sync'
export const pharmacy_rxnumber_date_sync_patients = 'pharmacy-rxnumber-date-sync/patients'
export const pharmacy_rxnumber_date_sync_prescriptions = 'pharmacy-rxnumber-date-sync/prescriptions'
export const half_baked_update_hbp = 'after-process-prep/half-baked/update-hbp'
export const send_delivery_access_code = 'send-delivery-access-code'
export const pharmacy_update_wit_rx = 'pharmacy-update-wit-rx'
export const pharmacy_admin_update_winrx_pharmacist = 'admin/update-winrx-pharmacist'
export const pharmacy_admin_rx_sheet_preview = 'rx-sheet-preview'
export const pharmacy_admin_rx_sheet_pharmacist_signatures = 'rx-sheet-preview/pharmacist'
export const pharmacy_admin_rx_sheet_patient_signatures = 'rx-sheet-preview/patient'
export const pharmacy_admin_rx_sheet_update_delivery_time = 'rx-sheet-preview/update-winrx-delivery-time'
export const pharmacy_admin_rx_sheet_update_delivery_status = 'rx-sheet-preview/update-winrx-delivery-status'
export const pharmacy_admin_rx_sheet_update_patient_sign = 'rx-sheet-preview/update-winrx-patient-sign'
export const pharmacy_admin_rx_sheet_update_witness_carry = 'rx-sheet-preview/update-winrx-witness-carry'
export const pharmacy_admin_rx_sheet_update_frequency_carry = 'rx-sheet-preview/update-frequency-carry'
export const pharmacy_admin_rx_sheet_signature_display_override = 'rx-sheet-preview/signature-display-override'
export const pharmacy_admin_rx_sheet_remove_signature_display_override = 'rx-sheet-preview/remove-signature-display-override'
export const patient_counselling = 'patient-counselling'
export const consent_submission_logs = 'consent-submission-logs'
export const patient_blister_pack = 'blister-patient'

export const get_last_seven_rdelivery = 'get-last-seven-rdelivery'
export const save_schedule_dose = 'save-schedule-dose'

export const blister_pack_patient = 'blister-pack-patient'
export const add_blister_pack = 'add-blister-pack'
export const update_blister_pack = 'update-blister-pack'
export const delete_blister_pack = 'delete-blister-pack'
export const print_dispense_blister = 'print-label-dispense-blister'
export const patient_checkrefills = 'patient-checkrefills'
export const add_medrx_notes = 'add-medrx-notes'
export const add_billing = 'add-billing'
export const print_label_dispense_blister = 'print-label-dispense-blister'

export const daily_blister_pack = 'daily-blister-pack'
export const update_blister_log = 'update-blister-log'
export const patient_bpack_onshelf = 'patient-bpack-onshelf'
export const patient_blisterack = 'patient-blisterack'
export const get_patient_active_medication = 'get-patient-active-medication'
export const pharmacy_serach_patient = '/pharmacy-serach-Patient'

export const vials_pateint_list = 'vials-pateint-list'
export const add_vials_pack = 'add-vials-pack'
export const vials_patient_pack = 'vials-patient-pack'
export const delete_vials_pack = 'delete-vials-pack'
export const update_vials_pack = 'update-vials-pack'
export const daily_vials_pack = 'daily-vials-pack'
export const update_vials_packlogs = 'update-vials-packlogs'
export const abel_validate_update_inputs = 'label-validate-update-inputs'
export const label_update_schdule_inputs = 'label-update-schdule-inputs'

export const pharmacy_sync_label_delivery = 'pharmacy-sync-labels-delivery'
export const pharmacy_print_lebel_setting = 'pharmacy-print-lebel-setting'
export const sMedication_patient_list = 'sMedication-patient-list'
export const add_sMedication_pack = 'add-sMedication-pack'
export const sMedication_pack_list = 'sMedication-pack-list'
export const update_sMedication_pack = 'update-sMedication-pack'
export const delete_sMedication_pack = 'delete-sMedication-pack'
export const sMedication_daily_log = 'sMedication-daily-log'
export const update_sMedication_log = 'update-sMedication-log'
export const pharmacy_generate_invoice = 'pharmacy-generate-invoice'
export const pharmacy_generate_invoice_srfax_form = 'pharmacy-generate-invoice-srfax-form'
export const pharmacy_previous_invoice = 'pharmacy-previous-invoice'
export const pharmacy_doctor_form = 'pharmacy-doctor-form'
export const consent_showimage = 'consent-showimage'
export const add_arv_details = 'add-patient-arv'

export const get_arv_lists = 'patient-arv-list'
export const delete_arv = 'delete-arv'
export const arv_fax_preview = 'arv-fax-preview'
export const arv_send_fax = 'arv-send-fax'
export const pharmacy_drugbilling = 'pharmacy-drugbilling'
export const prescription_dispense = 'prescription-dispense'
export const dispense_memo = 'patient-pending-memo'
export const update_reminder = 'update-pendingmemo-rdate'
export const pharmacy_revenue_list = 'pharmacy-revenue-list'
export const pharmacy_add_revenue = 'pharmacy-add-revenue'
export const add_multiple_revinue = 'add-multiple-revinue'

export const update_revinue_list = 'update-revinue-list'
export const delete_revenue = 'delete-revenue'
export const cash_change_list = 'cash-cashge-list'
export const cash_change_save = 'cash-change-save'
export const deposit_info_save = 'deposit-info-save'
export const pharmacy_deposit_list = 'pharmacy-deposit-list'
export const pharmacy_deposit_print = 'pharmacy-deposit-print'

export const delete_deposit_print = 'delete-deposit-print'
export const pharmacy_handcash = 'pharmacy-handcash'
export const save_handcash = 'save-handcash'
export const print_handcash = 'print-handcash'
export const delete_handcash = 'delete-handcash'

export const frequent_dispensing_autorization_submit = 'frequent-dispensing-autorization-submit'
export const frequent_dispensing_autorization_list = 'frequent-dispensing-autorization-list'
export const frequent_dispensing_authorization_view_pdf = 'frequent-dispensing-view-pdf'
export const update_frequent_deductible = 'update-frequent-deductibe'
export const frequent_dispensing_view_pdf = 'frequent-dispensing-view-pdf'

export const delete_frequent_log = 'delete-frequent-log'
export const pfrequent_expired_dispensing = 'pfrequent-expired-dispensing'
export const pharmacy_add_inventory = 'pharmacy-add-inventory'
export const pharmacy_api_inventory_list = 'pharmacy-api-inventory-list'
export const pharmacy_api_get_drug_by_din = 'pharmacy-api-get-drug-by-din'
export const pharmacy_api_sync_invertory = 'pharmacy-api-sync-invertory'
export const pharmacy_api_clear_inventory = 'pharmacy-api-clear-inventory'
export const pharmacy_authanticate_route = 'pharmacy-authanticate-route'
export const pharmacy_generate_routepasscode = 'pharmacy-generate-routepasscode'
export const getPharmacyRouteCode = 'get-pharmacy-routecode'
export const pharmacy_delete_inventory = 'delete-inventory'
export const update_inventory = 'update-inventory'

export const pharmacy_api_update_inventory = 'pharmacy-api-update-inventory'
export const pharmacy_route_patient = 'pharmacy-route-patient'
export const update_patient_delivery_note = 'update-patient-delivery-note'
export const patient_update_route = 'patient-update-route'
export const upload_prescription = 'upload-prescription'
export const pharmacy_travel_records = 'pharmacy-travel-records'
// export const pharmacy_travel_records  = 'pharmacy-travel-records'
export const upload_triplicate = 'upload-triplicate'
export const show_upload_image = 'show-upload-image'
export const pharmacy_reverse_rx = 'pharmacy-reverse-rx'
export const returned_fentanyl_patches = 'returned-fentanyl-patches'
export const returned_fentanyl_pdf = 'returned-fentanyl-pdf'
export const patches_send_fax = 'patches-send-fax'
export const upload_image_prescription = 'upload-image-prescription'
export const pharmacy_reverse_deliveries = 'pharmacy-reverse-deliveries'
export const pharmacy_reverse_deliveries_pdf = 'pharmacy-reverse-deliveries-pdf'
export const patient_assign_bshelfpacks = 'patient-assign-bshelfpacks'

// Pharmacare deductible / payment
export const pharmacy_pharmacare_store_payment = 'pharmacy-pharmacare-deductible/store-payment'
export const pharmacy_pharmacare_add_received_amount = 'pharmacy-pharmacare-deductible/add-received-amount'
export const pharmacy_pharmacare_deductible_list = 'pharmacy-pharmacare-deductible/list'
export const pharmacy_pharmacare_deductible_history = (deductibleId) => `pharmacy-pharmacare-deductible/deductible-history/${deductibleId}`
export const pharmacy_pharmacare_delete_deductibles = 'pharmacy-pharmacare-deductible/delete-deductibles'

export const pharmacy_transfer_prescription = 'pharmacy-app-prescription'
export const pharmacy_app_insurance_documents = 'pharmacy-app-insurance-documents'
export const pharmacy_order_details = 'pharmacy-order-details'
export const pharmacy_order_winrx_pdf = 'pharmacy-order-winrx-pdf'
export const pharmacy_order_winrx_retry = 'pharmacy-order-winrx-retry'
export const update_order_status_notes = 'update-order-status-notes'
export const p_app_users = 'p-app-users'
export const patient_refill_request = 'user-refill/list'
export const p_annoucement_list = 'p-annoucement-list'
export const pharmacy_annoucement_list = 'p-annoucement-list'
export const add_p_annoucement = 'add-p-annoucement'
export const p_custom_notification = 'p-custom-notification'
export const add_custom_notification = 'add-custom-notification'
export const update_p_announcement = 'update-p-annoucement'
export const update_order_parcel = 'update-order-parcel'

export const pharmacy_sorder_notes = 'pharmacy-sorder-notes'
export const update_pill_reminder = 'update-pill-reminder'
export const save_preview_fax = 'save-preview-fax'
export const delete_announcement = 'delete-announcement'
export const tb_skin_test_logs = 'pharmacy-tb-skin-log'
export const pharmacy_tb_log_pdf = 'pharmacy-tb-log-pdf'
export const pharmacy_last_log = 'pharmacy-last-log'
export const get_my_ip_address = 'https://api.ipify.org/?format=json'
export const p_trequest_users = 'p-trequest-users'
export const pharmacy_task = 'pharmacy-task'
export const puser_attendance_sheet = 'puser-attendance-sheet'
export const pharmacy_save_certifiate = 'pharmacy-save-certificate'
export const pharmacy_task_assignments_count = 'pharmacy-task/user-task-detail'

export const update_shift_users = 'update-shift-users'
export const delete_shift_user = 'delete-shift-user'
export const p_cinout_logs = 'p-checkin-outlogs'
export const update_break_setting = 'pharmacy-break-settings'
export const update_payroll_setting = 'pharmacy-payroll-settings'
export const pharmacy_certificate_template = 'p-certificate-template'
export const get_certificate_template = 'get-certificate-template'
export const update_certificate_template = 'update-certificate-template'
export const pharmacy_assign_certificate = 'get-assign-certificate'
export const assign_certificate_pdf = 'assign-certificate-pdf'

export const assign_certificate_employee = 'assign-certificate-employee'
export const pharmacy_team_users = 'pharmacy-team-users'
// Team → Onboarding Requests (admins only).
export const pharmacy_staff_onboarding = 'pharmacy-staff-onboarding'
export const pharmacist_signature_send_link = 'pharmacist-signature/send-signature-link'
export const pharmacist_signature_public = 'pharmacist-signature-public'
export const save_pharmacist_signature_public = 'save-pharmacist-signature-public'
export const pharmacy_user_departments = 'pharmacy-user-departments'
export const pharmacy_update_department = 'pharmacy-user-departments/saveDepartmentPermissions'
export const pharmacy_user_department = 'pharmacy-user-departments/saveUserDepartment'
export const on_boarding_user_profile = 'pharmacy-team-users/OnboardingUserProfile'
export const on_boarding_user_profile_update = 'pharmacy-team-users/updateOnboardingUserProfile'
export const sign_ai = 'pharmacy-RX-data'
export const patient_rxdelivered_diffrence = 'patient-rxdelivered-diffrence'
export const pharmacy_task_conversation = (taskId) => `pharmacy-task/${taskId}/conversations`

// -----------------Chat Users---------------
export const pharmacy_chat_users = 'chat/pharmacy-chat-users'
export const pharmacy_intiate_chat = 'chat/initiate-chat-users'
export const pharmacy_get_recent_chats = 'chat/recent-chat-users'
export const pharmacy_add_messages_to_group = 'chat/add-message-to-users'
export const pharmacy_chat_mark_as_unread_message = 'chat/mark-as-unread-message'
export const pharmacy_update_tu_online_status = 'chat/pharmacist-user-tu-online-status'

// -----------------Pharmacy juno Appointments---------------
export const pharmacy_juno_appointment_get_reasons = 'pharmacy-juno-appointment/get-reasions'
export const pharmacy_juno_appointment_get_provider = 'pharmacy-juno-appointment/get-provider'
export const pharmacy_juno_appointment_get_day_time_service_type = 'pharmacy-juno-appointment/get-day-time-service-type'
export const pharmacy_juno_appointment_get_provider_day_schedule = 'pharmacy-juno-appointment/get-provider-day-schedule'
export const pharmacy_juno_appointment_confirm_booking = 'pharmacy-juno-appointment/confirm-booking'
export const pharmacy_juno_appointment_get_appointment_list = 'pharmacy-juno-appointment/get-appontment-list'

export const pharmacy_patient_dwi_data = '/pharmacy-patient-dwi-data'
export const delete_patient_dwi_data = '/delete-patient-dwi-data'
export const download_dwi_data_pdf = '/download-dwi-data-pdf'
export const delete_all_dwi_data = '/delete-all-dwi-data'
export const restore_dwi_patient_data = '/restore-dwi-patient-data'

export const patient_archieved_exportsheet = '/patient-archieved-exportsheet'
export const setpin_patient_notification = '/setpin-patient-notification'
export const patient_archieved_exportpdf = '/patient-exportsheet-pdf'

// -----------------Vaccines---------------
export const pharmacy_patient_vaccine_fetch_details = '/pharmacy-patient-vaccine/fetch-detail'
export const pharmacy_patient_vaccine_download_certificate = '/pharmacy-patient-vaccine/download-certificate'
export const pharmacy_patient_vaccine_get_vaccine_list = '/pharmacy-patient-vaccine/get-vaccine-list'
export const pharmacy_patient_vaccine_get_dose_detail = '/pharmacy-patient-vaccine/get-dose-detail'
export const pharmacy_patient_vaccine_get_add_vaccine = '/pharmacy-patient-vaccine/add-vaccine'
export const pharmacy_patient_vaccine_download_multiple_certificate = '/pharmacy-patient-vaccine/download-multiple-certificate'
export const vaccine_download_multiple_certificate = '/pharmacy-patient-vaccine/download-vaccine-multiple-certificate'
export const pharmacy_patient_vaccine_logs = '/pharmacy-patient-vaccine/download-vaccine-certificate-log-list'
export const pharmacy_patient_vaccine_download_log_certificate = '/pharmacy-patient-vaccine/download-log-certificate'
export const pharmacy_patient_vaccine_update_dose = '/pharmacy-patient-vaccine/update-dose'
export const pharmacy_patient_vaccine_delete_dose = '/pharmacy-patient-vaccine/delete-dose'

// -----------------InvestigateRX---------------
export const patient_investigate_rx = '/patient-investigate-rx'
export const investigate_rx_metrics = '/investigate-rx-metrics'
export const investigate_rx_metrics_details = '/investigate-rx-metrics-details'
export const patient_investigate_rx_export_pdf = '/patient-investigate-rx-export-pdf'
export const patient_investigate_rxDetail = '/patient-investigate-rxDetail'
export const sync_investigateRX = '/sync-investigateRx'
export const patient_rxview_prescription = '/patient-rxview-prescription'
export const update_rx_do_not_send_schedule = '/update-rx-do-not-send-schedule'
export const patient_rxview_prescription_sync = '/patient-rxview-prescription-sync'
export const update_common_sig_prescription = '/update-common-sig-prescription'
export const pharmacy_rx_prescriptions_pdf = '/pharmacy-rx-prescriptions-pdf'
export const pharmacy_investigate_getinvestigateTemplate = '/getinvestigateTemplate'
export const pharmacy_investigate_getinvestigateTemplate_for_bulk = '/getinvestigateTemplate-for-bulk'
export const investigate_rx_stable_dose_history = '/investigate-rx-stable-dose-history'
export const pharmacy_save_multiple_pdf_template_data = '/save-multiple-pdf-template-data'
export const pharmacy_save_pdf_template_data = '/save-pdf-template-data'
export const pharmacy_preview_winrx_emergency_template_pdf = '/preview-winrx-emergency-template-pdf'
export const pharmacy_submit_winrx_emergency_template_pdf = '/submit-winrx-emergency-template-pdf'
export const update_login_pharmacist_cpsid = '/update-login-pharmacist-cpsid'
export const pharmacy_rx_signature_requestlog = '/rx-signature-requestlog'
export const pharmacy_rx_signature_send = '/rx-signature-send'
export const pharmacy_rx_signature_preview = '/rx-signature-preview'
export const check_bridge_connection = '/check-connectivity'
export const update_frequency_qty = '/dilaudid-frequency/save-frequency'
export const update_iv_code = '/dilaudid-frequency/update-iv-code'
export const update_dose_code = '/dilaudid-frequency/update-dose-code'
export const patient_rx_history = '/patient-rx-history'
export const pending_quantity_change_popup_reasons = '/pending-quantity-change-popup-reasons'
export const save_quantity_change_popup_reason = '/save-quantity-change-popup-reason'
export const pending_delivered_rx_reason_change_reviews = '/pending-delivered-rx-reason-change-reviews'
export const pending_delivered_rx_reason_change_reviews_export = '/pending-delivered-rx-reason-change-reviews-export'
export const delivered_rx_reason_change_review_reasons = '/delivered-rx-reason-change-review-reasons'
export const save_delivered_rx_reason_change_reviews = '/save-delivered-rx-reason-change-reviews'
export const pending_reprocessed_delivery_reviews = '/pending-reprocessed-delivery-reviews'
export const pending_reprocessed_delivery_reviews_export = '/pending-reprocessed-delivery-reviews-export'
export const reprocessed_delivery_review_reasons = '/reprocessed-delivery-review-reasons'
export const save_reprocessed_delivery_reviews = '/save-reprocessed-delivery-reviews'
const delivered_rx_reason_templates_base = '/delivered-rx-reason-templates'
export const delivered_rx_reason_templates = delivered_rx_reason_templates_base
export const delivered_rx_reason_templates_reorder = `${delivered_rx_reason_templates_base}/reorder`
export const delivered_rx_reason_template_by_id = delivered_rx_reason_templates_base
export const patient_rx_view_documents = '/get-document-by-filepath'
export const save_ai_dates = '/save-ai-dates'
export const update_prescription_quantity = '/update-prescription-quantity'
export const save_investigate_rx_note = '/save-investigate-rx-note'
export const get_rx_stock = '/pharmacy-get-rx-stock'
export const get_pharmacy_rx_day_wise_doses = '/get-pharmacy-rx-day-wise-doses'
export const sync_rx = '/sync-single-investigate-rx'
export const map_drug_rx_number = '/map-drug-rx-number'
export const get_patient_document_list = '/get-patient-document-list'
export const merge_archieved_delivery_sheets = '/merge-archieved-delivery-sheets'
export const update_do_not_bill = '/pharmacy-accountability/do-not-billed-status-update'
export const update_front_sig_check = '/update-front-sig-check'
export const investigation_ai_setting = '/investigation-ai-setting'
// MediFax OCR review (pharmacy ocr_mode = medifax): the fax's values for an Rx + per-field notes.
export const medifax_ocr_rx = '/medifax-ocr-rx'
export const medifax_ocr_note = '/medifax-ocr-note'
export const fridge_temperature_logs = '/fridge-temperature-logs'
export const fridge_temperature_fridges = '/fridge-temperature-fridges'
export const fridge_temperature_logs_pdf = '/fridge-temperature-logs/pdf'
export const get_winrx_mapping_data = '/get-winrx-mapping-data'
export const pharmacy_rx_sticky_note = '/pharmacy-rx-sticky-note'
export const investigate_din_group_drugs = '/investigate-din-group-drugs'
export const investigate_din_change_notice = '/investigate-din-change-notice'
export const pharmacy_rx_deleted_status = '/pharmacy-rx/deleted-status'

// -----------------Patient Soap Notes---------------
const soap_notes = '/pharmacy-patient-soap-notes';
export const fetch_soap_notes = `${soap_notes}/fetch-soap-note`;
export const create_soap_notes = `${soap_notes}/create-soap-note`;
export const update_drug_mask = `${soap_notes}/update-drug-mask`;
export const save_med_doctor_info = `${soap_notes}/save-med-doctor-info`;
export const doctor_auto_complete = `${soap_notes}/doctor-autocomplete`;
export const drug_auto_complete = `${soap_notes}/drug-autocomplete`;
export const sig_auto_complete = `${soap_notes}/sig-autocomplete`;
export const add_medications = `${soap_notes}/add-medications`;
export const pharmacy_soapnotes_pdf = `${soap_notes}/pharmacy-soapnotes-pdf`;
export const update_drug_reasons = `${soap_notes}/update-drug-reasons`;
export const med_rephrase_drp = `${soap_notes}/med-rephrase-drp`;
export const med_special_instructions = `${soap_notes}/generate-special-instructions`;
export const med_special_instructions_rephrase = `${soap_notes}/med-rephrase-rephrase_sp_inst`;
export const update_special_instructions = `${soap_notes}/update-special-instructions`;
export const translate_special_instructions = `${soap_notes}/translate-special-instructions`;
export const pharmacy_save_med_review = `${soap_notes}/pharmacy-save-med-review`;
export const pharmacy_send_medreview_signature_link = `${soap_notes}/pharmacy-send-medreview-signature-link`;
export const send_link_to_patient = `${soap_notes}/send-link-to-patient`;
export const pharmacy_generate_soap_notes = `${soap_notes}/generate-soap-notes`;
export const pharmacy_save_soap_notes = `${soap_notes}/save-soap-note`;
export const pharmacy_fetch_doctors_from_winrx = `${soap_notes}/fetch-winrx-doctors`;
export const pharmacy_fax_soap_note = `${soap_notes}/soap-note-fax`;
export const pharmacy_send_log_fax = `${soap_notes}/send-log-fax`;
export const pharmacy_download_medication_history = `${soap_notes}/download-bpmh-sheet`;
export const pharmacy_bpmh_fax_send = `${soap_notes}/fax-bpmh-sheet`;
export const pharmacy_verify_pharmacist = `${soap_notes}/pharmacy-pharmanent-verified`;
export const pharmacy_save_drp_identified = `${soap_notes}/save-drp-identified`;
export const check_logs_exists = `${soap_notes}/check-logs-exists`;
export const update_medreview_pdf_pharmacist = `${soap_notes}/update-medreview-pdf-pharmacist`;
export const rephrase_text = 'rephrase-text';

// -----------------Pharmacy SMS---------------
const pharmacy_sms = '/pharmacy-sms';
export const pharmacy_sms_conversation_list = `${pharmacy_sms}/ConversationList`
export const pharmacy_sms_add_conversation = `${pharmacy_sms}/start-Conversation`
export const pharmacy_sms_get_conversation_messages = `${pharmacy_sms}/getInitiateChats`
export const pharmacy_sms_send_message = `${pharmacy_sms}/sendPatientMessage`;
export const pharmacy_sms_get_list = `${pharmacy_sms}/presetMessages`;
export const pharmacy_sms_update_message = `${pharmacy_sms}/updatepresetMessage`;
export const pharmacy_sms_create_message = `${pharmacy_sms}/addPresetMessage`;
export const pharmacy_sms_sync_message = `${pharmacy_sms}/syncPresetMessages`;
export const pharmacy_delete_sms = `${pharmacy_sms}`;

// -----------------Packaging---------------
const packaging = '/pharmacy-packaging'
export const packaging_today_processing_data = `${packaging}/today-prcosseing-data`
export const pacaking_add_new_order = `${packaging}/add-new-order`
export const packaging_packing_wizard = `${packaging}/wizard`
export const packaging_stock_usage = `${packaging}/stock-usage`
export const packaging_order_preview = `${packaging}/cart-order-preview`
export const packaging_confirm_order = `${packaging}/createorder`
export const packaging_bulk_delete = `${packaging}/delete-multiple-log`
export const packaging_delete_single_log = `${packaging}/delete-log`
export const packaging_packmed_files = `${packaging}/all-dlogs`
export const packaging_din_management = `${packaging}/din-management`
// Who fulfils packaging orders: hub pharmacy ids + this pharmacy's self-fulfil
// switches. Ask the backend instead of hard-coding hub ids in the screens.
export const packaging_fulfilment_config = `${packaging}/fulfilment-config`
// One-time hub-fill vs self-fill choice. Serves BOTH modules; the module
// ('pacmed' | 'blister') is sent in the body.
export const packaging_fulfilment_choice = `${packaging}/fulfilment-choice`
export const packaging_incoming_orders = `${packaging}/incoming-orders/list`
export const packaging_download_order_txt = `${packaging}/incoming-orders/download-order-txt`
export const packaging_prn_processing = `${packaging}/prn-today-processing-data`
export const packaging_liquid_processing = `${packaging}/today-liquid-data`
export const packaging_order_details = `${packaging}/incoming-orders/view`
export const packaging_order_stock_data = `${packaging}/incoming-orders/order-stock-data`
export const packaging_all_invoices = `${packaging}/invoices`
export const packaging_view_invoice_pdf = `${packaging}/view-invoice-pdf`
export const packaging_invoice_details = `${packaging}/invoices-details`
export const packaging_update_invoice_status = `${packaging}/update-invoice-status`
export const packaging_stock_drugs = `${packaging}/incoming-orders/get-stock-Drugs`
export const packaging_send_invoice_email = `${packaging}/send-invoice-mail`
export const packaing_search_winrx_drug = `${packaging}/incoming-orders/search-winrx-drug`
export const packaing_update_drug = `${packaging}/incoming-orders/order/update-drug`
export const packaging_change_order_status = `${packaging}/incoming-orders/update-order-status`
export const packaging_get_updated_drugs = `${packaging}/incoming-orders/override-drug-pdf`
export const packaging_regenerate_invoice = `${packaging}/incoming-orders/regenerate-invoice`
export const packaging_total_incoming_orders_count = `${packaging}/incoming-orders/count`
export const packaging_partial_orders = `${packaging}/incoming-orders/partial-order-view`
export const packaging_partial_order_pdf = `${packaging}/incoming-orders/partial-order-pdf`
export const packaging_add_pack_orders = `${packaging}/add-pack-orders`
export const packaging_cart_list = `${packaging}/packaging-cart-list`
export const packaging_get_cart_logs = `${packaging}/get-cart-logs`
export const packaging_delete_package_cart = `${packaging}/delete-package-cart`
export const packaging_delete_package_prescription = `${packaging}/delete-package-log`
export const packaging_get_drug_list = `${packaging}/incoming-orders/get-packaging-drug-data`
export const packaging_stock_log = `${packaging}/incoming-orders/order-stock-log`
export const packaging_get_drug_family_data = `${packaging}/get-drug-family-data`
// Weekly-SIG schedule warning: collapse a flagged drug's carted rows to weekly (pre-order stage)
export const packaging_collapse_weekly_record = `${packaging}/collapse-weekly-record`
// Same fix on an existing (pending/processing) final order — fulfilling pharmacy only
export const packaging_collapse_weekly_order = `${packaging}/incoming-orders/order/collapse-weekly`
export const packaging_pacmed_invoice_logs = `${packaging}/pacmed/invoice-logs`

// -----------------Blister Packaging---------------
const blisterPackaging = '/pharmacy-blister-packaging'
export const blisterPackaging_todayProcessedData = `${blisterPackaging}/todays-pacmed-proccessed-data`
export const blisterPackaging_patientsPrescriptions = `${blisterPackaging}/get-patient-pcmedlogs`
export const blisterPackaging_deletePrescription = `${blisterPackaging}/delete-pacmed-record`
export const blisterPackaging_deletePatientWiseRecord = `${blisterPackaging}/delete-patientwise-record`
export const blisterPackaging_prnProcessingData = `${blisterPackaging}/today-prn-data`
export const blisterPackaging_liquidProcessingData = `${blisterPackaging}/today-liquid-data`
export const blisterPackaging_createNewOrder = `${blisterPackaging}/create-blister-order`
// Weekly-SIG schedule warning: collapse a flagged drug's pending rows to weekly (pre-order stage)
export const blisterPackaging_collapseWeeklyRecord = `${blisterPackaging}/collapse-weekly-record`
// Same fix on an existing (pending/processing) final order — fulfilling pharmacy only
export const blisterPackaging_collapseWeeklyOrder = `${blisterPackaging}/incoming-orders/order/collapse-weekly`
export const blisterPackaging_allIncomingOrders = `${blisterPackaging}/incoming-orders/list`
export const blisterPackaging_pacmed_files = `${blisterPackaging}/all-dlogs`
export const blisterPackaging_download_order_text = `${blisterPackaging}/incoming-orders/download-order-text`
export const blisterPackaging_allInvoices = `${blisterPackaging}/invoices`
export const blisterPackaging_invoiceDetails = `${blisterPackaging}/invoices-details`
export const blisterPackaging_viewInvoicePDF = `${blisterPackaging}/view-invoice-pdf`
export const blisterPackaging_updateInvoiceStatus = `${blisterPackaging}/update-invoice-status`
export const blisterPackaging_sendInvoiceEmail = `${blisterPackaging}/send-invoice-mail`
export const blisterPackaging_orderDetails = `${blisterPackaging}/incoming-orders/view`
export const blisterPackaging_viewOrderDetails = `${blisterPackaging}/incoming-orders/patient-view`
export const blisterPackaging_syncPacmedRecords = `${blisterPackaging}/sync-pacmed-record`
export const blisterPackaging_checkPacmedProgress = `${blisterPackaging}/check-pacmed-progress`
export const blisterPackaging_orderStockData = `${blisterPackaging}/incoming-orders/order-stock-data`
export const blisterPackaging_patientOrderDetails = `${blisterPackaging}/incoming-orders/patient-view-package`
export const blisterPackaging_stockDrugs = `${blisterPackaging}/incoming-orders/get-stock-Drugs`
export const blisterPackaging_updateDrugStock = `${blisterPackaging}/incoming-orders/order/update-drug`
export const blisterPackaging_changeOrderStatus = `${blisterPackaging}/incoming-orders/update-order-status`
export const blisterPackaging_get_updated_drugs = `${blisterPackaging}/incoming-orders/override-drug-pdf`
export const blisterPackaging_regenerateInvoice = `${blisterPackaging}/incoming-orders/regenerate-invoice`
export const blisterPackaging_partial_orders = `${blisterPackaging}/incoming-orders/partial-order-view`
export const blisterPackaging_partial_order_pdf = `${blisterPackaging}/incoming-orders/partial-order-pdf`
export const blisterPackaging_stockLog = `${blisterPackaging}/incoming-orders/order-stock-log`
export const blisterPackaging_deleteMultiplebpackPatient = `${blisterPackaging}/delete-multiple-bpack-patient`
export const blisterPackaging_deleteFinalOrder = `${blisterPackaging}/incoming-orders/delete-final-order`
export const blisterPackaging_updatePacmedRecords = `${blisterPackaging}/update-pacmed-records`
export const blisterPackaging_checkedByUserOrder = `${blisterPackaging}/incoming-orders/checkedby-user-order`
export const blisterPackaging_invoiceLogs = `${blisterPackaging}/invoice-logs`

// -----------------Accountability---------------
const accountability = '/pharmacy-accountability'
export const accountability_getPatientList = `${accountability}/rx-index`
export const accountability_getPatientRxDetail = `${accountability}/get-patient-rx-detail`
export const accountability_getRxAccountabilityPdf = `${accountability}/get-rx-accountability-pdf`
export const accountability_update_consultation = `${accountability}/update-consultation`
export const accountability_todayProcessedRoutes = `${accountability}/get-pending-routes`
export const accountability_prepareCheck = `${accountability}/prep-check`
export const accountability_getPatientList_v1 = `${accountability}/accountability-patient-search`


// export const accountability_prepareCheck_patientMedicationList = `${accountability}/patientMedicationList`
export const accountability_prepareCheck_patientMedicationList = `${accountability}/patientMedicationList-db`
export const accountability_assignDinLot = `${accountability}/assign-din-lot`
export const accountability_assignDinLotBulk = `${accountability}/assign-din-lot/bulk`
export const accountability_updateMultiDateSelection = `${accountability}/save-multiple-date-prepcheck`
export const accountability_updateMultiDateSelectionBulk = `${accountability}/save-multiple-date-prepcheck/bulk` 

export const accountability_prepareCheck_prepareAll = `${accountability}/update-prep-check`
export const accountability_pickup_log = `${accountability}/pick-route-logs`
export const accountability_pickup_single_route = `${accountability}/pick-single-route`
export const accountability_finalCheck_loadPatients = `${accountability}/final-check`
export const accountability_finalCheck_route_list = `${accountability}/final-check-route-list`
// export const accountability_finalCheck_patientPrescription = `${accountability}/get-finalcheck-final-medicine`
export const accountability_finalCheck_patientPrescription = `${accountability}/get-finalcheck-final-medicine-v1`
export const accountability_finalCheckMultiDates = `${accountability}/update-final-check-v1`
export const accountability_finalCheck_prepareAll = `${accountability}/update-final-check`
export const accountability_todayMissedRxRouteList = `${accountability}/today-missed-route`
export const accountability_todayMissedRxRouteListDetails = `${accountability}/today-missed-rx`
export const accountability_updateTodayPrepCheck = `${accountability}/update-today-prep-check`
export const accountability_updateFinalCheck = `${accountability}/update-final-prep-check`
export const accountability_updateAccountabilitySettings = `${accountability}/pharmacy-accountability-settings`



// export const accountability_prepButNotBilled = `${accountability}/prep-chk-not-billed`
export const accountability_prepButNotBilled = `${accountability}/prep-chk-not-billed-v1`
export const accountability_flexiDeliverList = `${accountability}/flexi-delivery-list`
export const accountability_patientPaymentCollectionList = `${accountability}/patient-payment-collection-list`
export const accountability_flexiDeliveryWinrxData = `flexi-delivery-winrx-data`
export const pharmacy_rx_document_rotations = `/rx-document-rotations`
export const accountability_flexiPatientTodayRx = `/flexi-patient-today-rx`
export const accountability_deliveryDriverList = `delivery-driver-list`
export const accountability_savePatientFlexiDelivery = `save-patient-flexi-delivery`
export const accountability_copayDeliveries = `pharmacy-patient-recopay-deliveries`
export const accountability_copayDeliveriesAcknowledge = `pharmacy-patient-recopay-deliveries/acknowledge`



export const accountability_billedButNotPrepared = `${accountability}/billed-not-prep-chk`
export const accountability_dropActiveRoute = `${accountability}/drop-active-route`
export const accountability_wrongPrep = `${accountability}/get-wrong-prep-list`
export const accountability_notBilledPrepWrongCount = `${accountability}/not-billed-prep-wrong-count`
export const accountability_drugInformationSheet = `drug-information-sheet`
export const accountability_getMissedRxData = `${accountability}/get-missed-rx-data`

export const team3x4xList = `${accountability}/get-missed-rx3x4x`

export const accountability_printLabels = `${accountability}/print-prep-delivery-lable`
export const accountability_pharmacyRxSearch = `pharmacy-rx-search`
export const accountability_generateLabelsByRxNumbers = `${accountability}/generate-labels-by-rx-numbers`
export const accountability_generateLabelsByRxDateRange = `${accountability}/generate-labels-by-rx-date-range`
export const accountability_dailyRoutineTemplate = `/pharmacy-user-daily-routine/template`
export const accountability_dailyRoutineSharedAvailability = `/pharmacy-user-daily-routine/shared/availability`
export const accountability_dailyRoutineSharedTemplates = `/pharmacy-user-daily-routine/shared`
export const accountability_dailyRoutineSharedTemplate = (id) => `/pharmacy-user-daily-routine/shared/${id}`
export const accountability_dailyRoutineSharedTemplateImport = (id) => `/pharmacy-user-daily-routine/shared/${id}/import`
export const accountability_dailyRoutineTemplateItems = `/pharmacy-user-daily-routine/template/items`
export const accountability_dailyRoutineTemplateItem = (id) => `/pharmacy-user-daily-routine/template/items/${id}`
export const accountability_dailyRoutineTemplateItemLookup = `/pharmacy-user-daily-routine/template/items/lookup`
export const accountability_dailyRoutineTemplateItemsReorder = `/pharmacy-user-daily-routine/template/items/reorder`
export const accountability_dailyRoutineToday = `/pharmacy-user-daily-routine/today`
export const accountability_dailyRoutineByDate = `/pharmacy-user-daily-routine/by-date`
export const accountability_dailyRoutineOverdue = `/pharmacy-user-daily-routine/overdue`
export const accountability_dailyRoutineHistory = `/pharmacy-user-daily-routine/history`
export const accountability_dailyRoutineStaff = `/pharmacy-user-daily-routine/staff`
export const accountability_dailyRoutineFilterUsers = `/pharmacy-user-daily-routine/filter-users`
export const accountability_dailyRoutineRunItemToggle = (id) => `/pharmacy-user-daily-routine/run-items/${id}/toggle`
export const accountability_acknCheckMissedRx = `${accountability}/update-acknowledge-data`
export const accountability_pharmacyAccountabilityReport = `${accountability}/pharmacy-accountability-report`
export const accountability_getReportRoutes = `${accountability}/get-report-routes`
export const accountability_downloadReport = `${accountability}/download-accountability-report-pdf`
export const accountability_getAccountabilityFinalReport = `${accountability}/download-report-pdf-status`
export const accountability_getEmergencyReport = `${accountability}/get-accountability-emergency-report`
export const accountability_downloadEmergencyReport = `${accountability}/get-accountability-emergency-report-pdf`
export const accountability_acknCheckMissedRx_WrongPrep = `${accountability}/acknowledge-rx`
export const accountability_forceDropActiveRoute = `${accountability}/force-drop-active-route`
export const accountability_singleDispenseRxStatusUpdate = `${accountability}/single-dispense-rx-status-update`
export const accountability_isScCarryDoseUpdate = `/pharmacy-update-is-sc-carry-dose`
export const accountability_updateMuteRX = `${accountability}/update-mute-rx-status`
// export const accountability_downloadBulkLabel = `${accountability}/prep-check-report-label`
export const accountability_downloadBulkLabel = `${accountability}/prep-check-bulk-label`
export const accountability_weeklyOddBillingSchedule = `${accountability}/weekly-odd-billing-schedule-rx`
export const accountability_oddBilling = `${accountability}/odd-schedule-rx`
// export const accountability_patientDrugInformationSheet = `${accountability}/pharmacy-patient-drug-information-sheet`
export const accountability_patientDrugInformationSheet = `${accountability}/pharmacy_new_rx_data`
export const accountability_rxDosesNotGenerated = `${accountability}/rx-doses-not-generated`
export const accountability_todayEmergencyRxData = `${accountability}/today-emergency-rx-data`
export const accountability_todayFirstEmergencyRx = `${accountability}/today-first-emergency-rx`


export const accountability_acknCheckNotBilled = `${accountability}/update-not-billed-acknowledgment`
export const accountability_changeDose = `${accountability}/get-change-dose-data`
export const accountability_futureChangingDose = `${accountability}/changing-dose-not-delivery`
export const accountability_fetchDWICounts = `/pharmacy-dwi-count`
export const accountability_newRxRouteList = `${accountability}/pharmacy-newrx-route-list`
export const accountability_newRxData = `${accountability}/pharmacy-newrx-data`
export const accountability_newRxCheck = `${accountability}/pharmacy-newrx-check`
export const accountability_acknCheckWitnessCarry = `/witness-carry-ack-check`

export const accountability_oddScheduleDynamicRx = `${accountability}/odd-schedule-dynamic-rx`
export const accountability_otherFrequencyData = `${accountability}/other-billing-frequency-rx`
export const accountability_markRefillFlexi = `${accountability}/mark-refill-flexi`
export const accountability_dilaudidData = `/dilaudid-rx-today`
export const accountability_dilaudidRxOverwrite = `/update-dilaudid-pacmed-overwrite`
export const check_rxnumber_dilaudid = `/check-rxnumber-dilaudid`
export const accountability_dilaudidRxTodayPdf = `/dilaudid-rx-today/pdf`
export const accountability_dilaudidPreviousPdf = `/dilaudid-rx-yesterday/pdf`
export const accountability_dilaudid_same_bid = `/dilaudid-rx-today/same-bid`
export const accountability_dilaudid_rx_today_all = `/dilaudid-rx-today/all-safesupply`
export const accountability_send_dilaudid_fax_to_doctor = `/send-dilaudid-fax-to-doctor`
export const accountability_dilaudid_different_bid = `/dilaudid-rx-today/different-bid`
export const accountability_dilaudid_others = `/dilaudid-rx-today/others`
// Non Safe Supply tab: multi-dose prescriptions where a later dose was never processed.
export const accountability_non_safe_supply_missed_doses = `/non-safe-supply-rx-today/missed-doses`
export const accountability_arv_rxes = `arv-rxes`
export const accountability_arv_rx_data_preview_for_fax = `arv-rx-data-preview-for-fax`
export const accountability_arv_rx_send_fax = `arv-rx-send-fax`
export const accountability_arv_rx_fax_list = `arv-rx-fax-list`
export const accountability_arv_rx_fax_view_pdf = `arv-rx-fax-view-pdf`
export const accountability_refills_request = `pharmacy-reffills-request/list`
export const accountability_refills_data_preview_for_fax = `pharmacy-reffills-request/preview-fax`
export const accountability_refills_send_fax = `pharmacy-reffills-request/send-fax`
export const accountability_refills_fax_list = `pharmacy-reffills-request/fax-logs`
export const accountability_refills_fax_view_pdf = `pharmacy-reffills-request/fax-log-view-pdf`
export const accountability_refills_drug_family_list = `pharmacy-drug-family/drug-family `
export const accountability_refills_drug_family_list_patient = `pharmacy-drug-family/patients`
export const accountability_refills_drug_family_list_analytics = `pharmacy-analytics/drug-dispensed`
export const accountability_drug_quantity_by_date = `analytics/drugs/drug-quantity-by-date`
export const accountability_generate_fax_pdf = `pharmacy-reffills-request/generate-fax-pdf`
export const accountability_prepCheck_sTsfRc = `${accountability}/prep-chk-s-tsf-rc`
export const accountability_acknCheckDoNotBill = `${accountability}/acknowledge-prep-chk`
export const accountability_schedule_rx = `rx-changing/schedule-comparison`
export const rx_changing_unsent_schedules = `rx-changing/unsent-schedules`
export const rx_changing_unsent_schedules_send = `rx-changing/unsent-schedules/send`
export const accountability_drug_visual_intake_missing_dins = `drug-visual-intake/missing-dins`
export const drug_visual_intake = `drug-visual-intake`
export const accountability_missing_witness_carry_rx = `/missing-witness-carry-rx`
export const accountability_afterProcessPrepRouteList = `/after-process-prep/routelist`
export const accountability_afterProcessPrepRouteRxData = `/after-process-prep/route-rx-data`
export const accountability_afterProcessPrepRxDataByIds = `/after-process-prep/rx-data-by-ids`
export const half_baked_list = `/after-process-prep/half-baked/list`
export const half_baked_regenerate = `/after-process-prep/half-baked/regenerate`
export const half_baked_compare = `/after-process-prep/half-baked/compare`
export const half_baked_process_selected = `/after-process-prep/half-baked/process-selected`
export const accountability_deliveryDriverListAfterProcessPrep = `/delivery-driver-list`
export const accountability_savePatientFlexiDeliveryAP = `/save-patient-flexi-delivery`

// Payroll OTP APIs
export const payroll_otp_request = 'checks/otp/request'
export const payroll_otp_verify = 'checks/otp/verify'
export const paycheck_companies = 'payrollchecks'
export const paycheck_companies_list = 'checks/paycheck-companies'
export const paycheck_companies_by_id = 'checks/paycheck-companies'
export const get_paycheck_company_details = 'checks/paycheck-companies/show-company'
export const paycheck_companies_export_to_finance = 'checks/paycheck-companies/export-to-finance'
export const authorized_phones = 'checks/authorized-phones'
export const delete_authorized_phone = 'checks/authorized-phones'
export const check_bookkeeper_module_access = 'checks/show-bookkeeper-module'
export const payroll_templates = 'payrollchecks/payroll-template-data'
export const create_payroll_checks = 'payrollchecks/pharmacy-payrollchecks'
export const get_pharmacies = 'get-pharmacies'
export const link_pharmacy_share_paychecks = 'payrollchecks/link'
export const get_linked_pharmacies = 'payrollchecks/linked-pharmacies/direct'
export const get_linked_pharmacies_overview = 'payrollchecks/linked-pharmacies'
export const unlink_pharmacy_share_paychecks = 'payrollchecks/unlink'
export const check_users = 'payrollchecks/check-users'
export const check_users_by_company = 'payrollchecks/check-users/company'
export const payroll_checks_list = 'payrollchecks/pharmacy-payrollchecks/list'
export const update_payroll_check_status = 'payrollchecks/status'
export const generate_payroll_pdf = 'payrollchecks/generate-payroll-pdf'
export const get_last_check_no = 'payrollchecks/get-last-check-no'
export const reissue_payroll_check = 'payrollchecks/reissue'
export const import_payroll_csv = 'payrollchecks/import-csv'
export const get_user_by_token = 'payrollchecks/get-user-by-token'
export const update_check_user_by_token = 'payrollchecks/update-check-user-by-token'
export const submit_payroll_signature = 'payrollchecks/submit-signature'
export const send_signature_link = 'payrollchecks/send-signature-link'
export const check_user_by_sign_token = 'payrollchecks/check-user-by-sign-token'
export const get_payee_names = 'checks/paycheck-companies/payee-names'
export const extract_payroll_pdf = 'payrollchecks/extract-payroll-pdf'


// Financial/Accounting OTP APIs (different from payroll)
export const financial_otp_request = 'finance/login/otp/send'
export const financial_otp_verify = 'finance/login/otp/verify'

// Unified Bookkeeper and Finance OTP APIs
export const unified_otp_request = 'common-bookkeeper-finance/otp/send'
export const unified_otp_verify = 'common-bookkeeper-finance/otp/verify'

// Super Nova OTP APIs
export const supernova_otp_send = 'supernova/login/otp/send'
export const supernova_otp_verify = 'supernova/login/otp/verify'
export const supernova_logout = 'supernova/logout'

// Financial/Accounting Business APIs
export const finance_create_business = 'finance/businesses'
export const finance_get_businesses = 'finance/businesses'
export const finance_accessible_businesses = 'finance/accessible-businesses'
export const finance_update_business = 'finance/businesses'
export const finance_export_to_bookkeeper = 'finance/businesses/export-to-bookkeeper'
export const finance_import_expenses = 'finance/transactions/import-expenses'
export const finance_logout = 'finance/logout'
export const finance_delete_bank = 'finance/businesses/banks'
export const finance_transactions = 'finance/transactions'
export const finance_transactions_chart_data = 'finance/transactions/chart-data'
export const finance_transactions_export_csv = 'finance/transactions/export-csv'
export const accounting_access_form = 'finance/users'
export const finance_current_user = 'finance/users/current'
export const finance_linked_pharmacies_direct = 'finance/linked-pharmacies/direct'
export const finance_link_pharmacy = 'finance/link-pharmacy'
export const finance_unlink_pharmacy = 'finance/unlink-pharmacy'
export const finance_transactions_update_memo = 'finance/transactions'
export const finance_bills = 'finance/bills'
export const finance_bills_attach_to_transaction = 'finance/bills/attach-to-transaction'

//------------Patient Profile---------------
const patientprofile = '/pharmacy-patient-profile'

export const patientProfile_searchData = `${patientprofile}/data`
export const patientProfile_getPatientProfile = `${patientprofile}/get-patient-profile`
export const patientProfile_pharmanetView = `${patientprofile}/pharmanet/view`
export const patientProfile_pharmanetPull = `${patientprofile}/pharmanet/pull`
export const patientProfile_pharmanetElsewhere = `${patientprofile}/pharmanet/elsewhere`
export const patientProfile_pharmanetLoyalty = `${patientprofile}/pharmanet/loyalty`
export const patientProfile_pharmanetRemove = `${patientprofile}/pharmanet/remove`
export const patientProfile_pharmanetIgnore = `${patientprofile}/pharmanet/ignore`
export const patientProfile_pharmanetBatchRun = `${patientprofile}/pharmanet/batch-run`
export const patientProfile_updatePatientProfile = `${patientprofile}/update-profile`
export const patientProfile_updateProfileImage = `${patientprofile}/update-patient-profile`
export const patientProfile_ActiveMedicineList = `${patientprofile}/get-patient-medicine`
export const patientProfile_BlisterMedicineList = `${patientprofile}/get-patient-blister-medicine`
export const patientProfile_getPatientMedicineByDin = `${patientprofile}/get-patient-medicine-by-din`
export const patientProfile_AllMedicineList = `${patientprofile}/get-patients-all-rx`
export const patientProfile_updatePatientVitalDriver = `${patientprofile}/update-patient-vital-driver`
export const patientProfile_getPatientVitals = `${patientprofile}/get-patient-vitals`
export const patientProfile_getPatientVitalAndHcpDriver = `${patientprofile}/get-patient-vital-and-hcp-driver`
export const patientProfile_DeliveryHistory = `${patientprofile}/get-patient-delivery-history`
export const pharmacy_driver_hcp_list = 'pharmacy-driver-hcp-list'
export const patientProfile_generateDailyVitalCollectionPdf = `${patientprofile}/generate-daily-vital-collection-pdf`

// -----------------Analytics---------------
const analytics = '/analytics'

// export const analytics_top_drugs = `${analytics}/drugs/top-drugs`
// export const analytics_drugs_packmed_orders = `${analytics}/drugs/pacmed-orders`
// export const analytics_pacmed_drugs = `${analytics}/drugs/get-pacmed-drugs`
// export const analytics_pacmed_pharmacy_list = `${analytics}/drugs/getPacMedToPharmacyList`
// export const analytics_top_pharmacies = `${analytics}/drugs/top-pharmacies`


export const analytics_top_drugs = `${analytics}/drugs/top-drugs`
export const analytics_drugs_packmed_orders = `${analytics}/drugs/blister-pacmed-orders`
export const analytics_pacmed_drugs = `${analytics}/drugs/get-pacmed-drugs`
export const analytics_pacmed_pharmacy_list = `${analytics}/drugs/getPacMedToPharmacyList`
export const analytics_top_pharmacies = `${analytics}/drugs/top-pharmacies`

export const changelog = 'changelog'
export const changelog_today_count = 'changelog/today-count'
export const changelog_important_pending = 'changelog/important-pending'
export const changelog_acknowledge = (id) => `changelog/${id}/acknowledge`
export const admin_announcements_active = 'admin-announcements/active'

// -----------------New RX List---------------
export const pharmacy_new_rx_list = 'pharmacy-new-rx-list'
export const pharmacy_narcotic_rx_by_date = 'pharmacy-narcotic-rx-by-date'
export const pending_safe_supply_missing_iv_code_reviews = 'pending-safe-supply-missing-iv-code-reviews'

































































// Fentanyl Patch Return & Destruction Log (Dispense > Fentanyl Patch Log)
const patch_log = 'patch-log'
export const patch_log_returns = `${patch_log}/returns`
export const patch_log_returns_summary = `${patch_log}/returns/summary`
export const patch_log_returns_to_count = `${patch_log}/returns/to-count`
export const patch_log_returns_prefill = `${patch_log}/returns/prefill`
export const patch_log_containers = `${patch_log}/containers`
export const patch_log_methods = `${patch_log}/methods`
export const patch_log_batches = `${patch_log}/batches`
export const patch_log_batches_destroy_now = `${patch_log}/batches/destroy-now`
export const patch_log_export_csv = `${patch_log}/export/csv`
export const patch_log_incidents = `${patch_log}/incidents`
